import { request, requestWithAccessToken } from '@owl-nest/api-client/compat'

const pool = {}

const connector = (options) => {
  const getUrl = (url = '') => {
    return options.url + url
  }

  const getHeaders = () => {
    return options.headers
  }

  const get = (url = '', options = {}) => {
    const { withAccessToken, headers } = options

    const fn = withAccessToken ? requestWithAccessToken : request

    return fn(getUrl(url), {
      headers: {
        ...getHeaders(),
        ...headers,
      },
    })
  }

  const post = (url = '', options = {}) => {
    const { withAccessToken, body, headers, type = 'json' } = options

    const fn = withAccessToken ? requestWithAccessToken : request

    return fn(getUrl(url), {
      method: 'post',
      body,
      type,
      headers: {
        ...getHeaders(),
        ...headers,
      },
    })
  }

  const patch = (url = '', data = {}, options = {}) => {
    const { headers, type = 'json', withAccessToken } = options

    const fn = withAccessToken ? requestWithAccessToken : request

    return fn(getUrl(url), {
      method: 'PATCH',
      body: data.body,
      type,
      headers: {
        ...getHeaders(),
        ...headers,
      },
    })
  }

  const _delete = (url = '', data = {}) => {
    return requestWithAccessToken(getUrl(url), {
      method: 'DELETE',
      body: data,
      headers: getHeaders(),
    })
  }

  const upload = (url = '', options = {}) => {
    const { withAccessToken, body } = options

    const fn = withAccessToken ? requestWithAccessToken : request

    return fn(getUrl(url), {
      method: 'post',
      type: 'formData',
      body,
      headers: getHeaders(),
    })
  }

  const me = (extraFields) => {
    if (extraFields && extraFields.length) {
      return requestWithAccessToken(getUrl(`/me?extra_fields=${extraFields}`), {
        headers: getHeaders(),
      })
    }
    return requestWithAccessToken(getUrl('/me'), { headers: getHeaders() })
  }

  return {
    get: get,
    post: post,
    patch: patch,
    upload: upload,
    delete: _delete,
    me,
  }
}

export const configure = (options) => {
  Object.keys(options).forEach((apiName) => {
    pool[apiName] = connector(options[apiName])
  })
}

export const api = (apiName) => {
  return pool[apiName]
}
